import {
  LOAD_FAVOURITES,
  TOGGLE_FAVOURITE,
  UPDATE_FAVOURITE_ORDER
} from './constants'

export const toggleFavourite = (favourite) => ({
  type: TOGGLE_FAVOURITE,
  favourite
})

export const loadFavourites = (favourites) => ({
  type: LOAD_FAVOURITES,
  favourites
})

export const UpdateFavouritesOrder = (favourites) => ({
  type: UPDATE_FAVOURITE_ORDER,
  favourites
})
